import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  CustomCheckbox,
  CustomDataTableHeader,
  CustomPanel,
  PageHeader,
} from '../../../../components'
import { TIPOS_RETENCAO_ISS } from '../../../../constants/fiscal'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import {
  formatarCodigoNbs,
  formatarCodigoTributacaoNacional,
} from '../../Fiscal/EmitirNfse/emitirNfse.util'
import useServicoNfse, { LOAD_MESSAGE } from './ServicoNfseHook'
import ServicoNfseModal from './ServicoNfseModal'

function ServicoNfse({ history, selectedTp, dispatch }) {
  const { state, localDispatch } = useServicoNfse()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.LOADING:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.loadServicos(selectedTp)
        break

      default:
        break
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetErrorMessage()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.errorMessage])

  return (
    <div>
      <PageHeader>2.21 - Serviços (NFS-e)</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={() => localDispatch.onBtnNovo(selectedTp)} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-12">
              <DataTable
                value={state.servicos}
                header={
                  <CustomDataTableHeader
                    onChange={value => localDispatch.onGlobalFilterChange(value)}
                  />
                }
                emptyMessage={'Nenhum serviço cadastrado . . .'}
                globalFilter={state.globalFilter}
                paginator={true}
                rows={10}
                selectionMode="single"
                onSelectionChange={e => localDispatch.onDataTableItemClicked(e.value)}
              >
                <Column field="id" header="Código" style={tableCellCentered(80)} />
                <Column field="descricao" header="Descrição" />
                <Column
                  field="codigo_tributacao_nacional"
                  header="Cód. Tributação Nacional"
                  style={tableCellCentered(190)}
                  body={item => formatarCodigoTributacaoNacional(item.codigo_tributacao_nacional)}
                />
                <Column
                  field="codigo_nbs"
                  header="NBS"
                  style={tableCellCentered(130)}
                  body={item => formatarCodigoNbs(item.codigo_nbs)}
                />
                <Column
                  field="aliquota_iss"
                  header="Alíquota ISS"
                  style={tableCellCentered(110)}
                  body={item =>
                    item.aliquota_iss !== null && item.aliquota_iss !== undefined
                      ? `${String(item.aliquota_iss).replace('.', ',')}%`
                      : '—'
                  }
                />
                <Column
                  header="Retenção ISS"
                  style={tableCellCentered(170)}
                  body={item => {
                    const retencao = TIPOS_RETENCAO_ISS.find(
                      opcao => opcao.value === item.tipo_retencao_iss,
                    )
                    return retencao ? retencao.label : ''
                  }}
                />
                <Column
                  field="padrao_frete_municipal"
                  header="Padrão frete municipal"
                  style={tableCellCentered(120)}
                  body={item => <CustomCheckbox checked={item.padrao_frete_municipal} />}
                />
                <Column
                  field="actived"
                  header="Ativo"
                  style={tableCellCentered(80)}
                  body={item => <CustomCheckbox checked={item.actived} />}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <ServicoNfseModal
        show={state.modal.show}
        data={state.modal.data}
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(ServicoNfse))
